import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';

const ProfilePlatformData = ({ influencer }) => {
  const name = influencer.name;
  const statisticsUpdatedDate = influencer.statisticsUpdatedDate;
  const dataRefreshMessage = `Data collected ${moment(statisticsUpdatedDate).fromNow()}`;
  const totalSocialReachDayChange = influencer.totalSocialReachDayChange;
  const totalSocialReach = influencer.totalSocialReach;
  const calculateDayOnDayGrowth = (totalReach, dayChange) => {
    const percentageGrowth = dayChange / totalReach;
    return percentageGrowth;
  };

  const dayOnDayGrowth = calculateDayOnDayGrowth(totalSocialReach, totalSocialReachDayChange);
  const trending = dayOnDayGrowth > 0.01;

  return (
    <Segment padded>
      <h3>Data</h3>
      <Table basic="very">
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <h2>{numeral(totalSocialReachDayChange).format('0,0')}&nbsp;&nbsp;</h2>
            </Table.Cell>
            <Table.Cell>
              <b>Follower day change</b><br />
              {dataRefreshMessage}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <h2>{numeral(dayOnDayGrowth).format('+0.0%')}&nbsp;&nbsp;</h2>
            </Table.Cell>
            <Table.Cell>
              <b>Day on day change</b><br />
              {dataRefreshMessage}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      { trending && <p><b>{name} is currently trending</b></p> }
    </Segment>
  );
};

ProfilePlatformData.propTypes = {
  influencer: PropTypes.object.isRequired,
};

export default ProfilePlatformData;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-platform-data.js
 **/